'use client';

import { CldImage } from 'next-cloudinary';
import PropertyGallery from '@/components/elements/Properties/PropertyGallery';
import { useState } from 'react';
import { GripIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PropertyGalleryThumbs({ images }: { images: string[] }) {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [clickedImage, setClickedImage] = useState(0);

  return (
    <div className="relative rounded-xl overflow-hidden">
      <div className="grid gap-2 sm:grid-cols-4">
        {images.slice(0, 5).map((image: string, index: number) => (
          <div
            key={image}
            onClick={() => {
              setClickedImage(index);
              setIsGalleryOpen(true);
            }}
            className={
              index === 0
                ? 'col-span-2 row-span-2 relative overflow-hidden rounded-md transition-all after:opacity-0 after:absolute after:inset-0 after:bg-black hover:after:opacity-20 focus:after:opacity-20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 dark:focus-visible:ring-gray-300 cursor-pointer'
                : 'col-span-1 row-span-1 relative overflow-hidden rounded-md transition-all after:opacity-0 after:absolute after:inset-0 after:bg-black hover:after:opacity-20 focus:after:opacity-20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 dark:focus-visible:ring-gray-300 cursor-pointer'
            }
          >
            <CldImage
              className="object-cover aspect-square"
              width="1440"
              height="1080"
              alt="Property image"
              src={image}
              priority={index === 0}
            />
          </div>
        ))}
      </div>

      <Button
        variant="secondary"
        size="sm"
        className="absolute gap-1 bottom-4 right-4 cursor-pointer"
        onClick={() => {
          setClickedImage(0);
          setIsGalleryOpen(true);
        }}
      >
        <GripIcon className="w-4 h-4" />
        Show all photos
      </Button>

      <PropertyGallery
        startIndex={clickedImage}
        images={images}
        isGalleryOpen={isGalleryOpen}
        setIsGalleryOpen={setIsGalleryOpen}
      />
    </div>
  );
}
